<template>
  <div class="fzmProductPage">
    <div class="container-fluid">

        <b-row>
            <b-col cols="5" md="4" lg="3">
                <template v-if="issubscription && subscriptions.length > 0">
                    <button 
                        @click="$router.push({name : 'ordersubscription'})" 
                        class="btn btn-primary sm-only">Back</button>
                </template>

                 <order-boxes 
                    :activebox.sync="activebox"/>
            </b-col>

            <b-col cols="7" md="8" lg="5">
                <div class="flavordetailswrapper">
                    <template v-if="issubscription && subscriptions.length > 0">
                        <button 
                            @click="$router.push({name : 'ordersubscription'})" 
                            class="btn btn-primary hidden-sm">Back</button>
                    </template>

                    <order-details 
                        :activebox="activebox"/> 

                    <div class="fillboxwrapper show-md">
                        <fill-box :activebox="activebox"/>
                    
                        <div class="remainingStocks">
                            <!-- 100 dozen remaning -->
                        </div>
                    </div>
                </div>
            </b-col>

            <b-col lg="4" offset-md="4" offset-lg="0">
                <div class="fillboxwrapper hidden-md">
                    <fill-box :activebox="activebox"/>
                
                    <div class="remainingStocks">
                        <!-- 100 dozen remaning -->
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>

</div>
</template>

<script>
// components
import orderBoxes from '@/components/productOrderBoxes.vue';
import orderProductDetails from '@/components/orderProductDetails.vue';
import orderProductFillBox from '@/components/productOrderFillBox.vue';

export default {
    components : {
        'order-boxes'  : orderBoxes,
        'order-details': orderProductDetails,
        'fill-box'     : orderProductFillBox
    },
    computed : {
        /**
         * Order type
         */
        issubscription() {
            return this.$store.state.issubscription
        },
        /** 
         * Subscriptoin list
        */
       subscriptions() {
           return this.$store.state.subscriptions
       }
    },
    data() {
        return {
            activebox : 0
        }
    }
}
</script>

<style lang="scss">

</style>